import { forwardRef } from "react";
import { Drawer as DrawerPrimitive } from "vaul";

import {
  type TDrawerTitleElement,
  type TDrawerTitleProps,
} from "@/ui/components/overlay/Drawer/Drawer.config";
import { cn } from "@/ui/lib/utils";
import { TextSubtitle } from "@/ui/components/typography/TextSubtitle";

export const DrawerTitle = forwardRef<TDrawerTitleElement, TDrawerTitleProps>(
  ({ className, children, ...props }, ref) => (
    <DrawerPrimitive.Title
      data-component="DrawerTitle"
      ref={ref}
      className={cn("text-foreground", className)}
      {...props}
    >
      <TextSubtitle tag="span" size={3} isResponsive={false} align="center" className="block">
        { children }
      </TextSubtitle>
    </DrawerPrimitive.Title>
  ),
);

DrawerTitle.displayName = "DrawerTitle";
